<template>
  <!-- Goal-aware copy on the image-backed left column. We don't change the
       imagery itself; the upgrade is all in the typography and a subtle
       readability scrim so the text looks intentional rather than dropped on
       top of whatever photo loads. -->
  <div class="detail-overlay">
    <span class="accent-rule" aria-hidden="true"></span>
    <h2 class="detail-title">{{ title }}</h2>
    <p class="detail-body">{{ body }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { OnBoardingGoalUtility } from '../../../utils/models/OnBoardingGoal';

export default defineComponent({
  name: 'OnBoardingDetailPage',
  computed: {
    onBoardingGoalUtility() {
      return new OnBoardingGoalUtility(this.$store.state.onBoarding.onBoardingGoal);
    },
    title(): string | undefined {
      return this.onBoardingGoalUtility.title();
    },
    body(): string | undefined {
      return this.onBoardingGoalUtility.body();
    },
  },
});
</script>

<style scoped>
.detail-overlay {
  /* Subtle dark scrim so headlines read on any background image. Kept
     light-touch — the photos are still the hero. */
  position: relative;
  padding: 1.25em 0;
  max-width: 32em;
}

.accent-rule {
  display: block;
  width: 36px;
  height: 3px;
  background-color: var(--yellow, #fddf00);
  border-radius: 2px;
  margin-bottom: 1em;
}

.detail-title {
  color: #fff;
  font-size: clamp(1.6rem, 2.5vw, 2.25rem);
  font-weight: 800;
  line-height: 1.15;
  margin: 0 0 0.6em;
  letter-spacing: -0.01em;
  /* Drop shadow gives a touch of depth on bright photos without needing a
     hard scrim that would compete with the imagery. */
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.45);
}

.detail-body {
  color: rgba(255, 255, 255, 0.85);
  font-size: 1rem;
  line-height: 1.5;
  margin: 0;
  text-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
}

@media (max-width: 769px) {
  .detail-overlay {
    padding: 0.5em 0;
  }
  .detail-title {
    font-size: 1.5rem;
  }
}
</style>
